import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import React from 'react';
import { GroupContext } from './group-context.js';
import CheckboxControlInner from './checkbox-control-inner.js';

var CheckboxControl = React.forwardRef(function CheckboxControl(props, ref) {
  return React.createElement(GroupContext.Consumer, null, function (_ref) {
    var inGroup = _ref.inGroup,
        handleCheckboxChange = _ref.handleCheckboxChange,
        groupValue = _ref.value,
        error = _ref.error,
        theme = _ref.theme,
        size = _ref.size,
        disabled = _ref.disabled;

    if (!inGroup) {
      return React.createElement(CheckboxControlInner, _extends({
        ref: ref
      }, props));
    }

    var value = props.value;
        props.defaultChecked;
        props.onChange;
        props.checked;
        var propsError = props.error,
        propsDisabled = props.disabled,
        propsTheme = props.theme,
        propsSize = props.size,
        restProps = _objectWithoutProperties(props, ["value", "defaultChecked", "onChange", "checked", "error", "disabled", "theme", "size"]);

    return React.createElement(CheckboxControlInner, _extends({
      error: error || propsError,
      value: value,
      onChange: handleCheckboxChange,
      checked: _includesInstanceProperty(groupValue).call(groupValue, value),
      disabled: disabled || propsDisabled,
      theme: theme || propsTheme,
      size: size || propsSize,
      ref: ref
    }, restProps));
  });
});
CheckboxControl.propTypes = CheckboxControlInner.propTypes;

export { CheckboxControl as default };
